import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCovid = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.125 12C5.125 13.8234 5.84933 15.572 7.13864 16.8614C8.42795 18.1507 10.1766 18.875 12 18.875C13.8234 18.875 15.572 18.1507 16.8614 16.8614C18.1507 15.572 18.875 13.8234 18.875 12C18.875 10.1766 18.1507 8.42795 16.8614 7.13864C15.572 5.84933 13.8234 5.125 12 5.125C10.1766 5.125 8.42795 5.84933 7.13864 7.13864C5.84933 8.42795 5.125 10.1766 5.125 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4584 2.625H12.0001H10.5417"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 2.625V5.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.40175 4.34L5.37092 5.37083L4.34009 6.40166"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.37085 5.37082L7.13835 7.13832"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 10.5417V12V13.4583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 12H5.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.34009 17.5983L5.37092 18.6292L6.40175 19.66"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.37085 18.6292L7.13835 16.8617"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5417 21.375H12.0001H13.4584"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 21.375V18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5984 19.66L18.6292 18.6292L19.6601 17.5983"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6291 18.6292L16.8616 16.8617"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 13.4583V12V10.5417"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 12H18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6601 6.40166L18.6292 5.37083L17.5984 4.34"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6291 5.37082L16.8616 7.13832"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5417 12.2083C15.5417 12.3188 15.5856 12.4248 15.6638 12.503C15.7419 12.5811 15.8479 12.625 15.9584 12.625C16.0689 12.625 16.1749 12.5811 16.253 12.503C16.3312 12.4248 16.3751 12.3188 16.3751 12.2083C16.3751 12.0978 16.3312 11.9918 16.253 11.9137C16.1749 11.8356 16.0689 11.7917 15.9584 11.7917C15.8479 11.7917 15.7419 11.8356 15.6638 11.9137C15.5856 11.9918 15.5417 12.0978 15.5417 12.2083Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2083 15.9583C12.2083 16.0688 12.2522 16.1748 12.3303 16.253C12.4084 16.3311 12.5144 16.375 12.6249 16.375C12.7354 16.375 12.8414 16.3311 12.9195 16.253C12.9977 16.1748 13.0416 16.0688 13.0416 15.9583C13.0416 15.8478 12.9977 15.7418 12.9195 15.6637C12.8414 15.5856 12.7354 15.5417 12.6249 15.5417C12.5144 15.5417 12.4084 15.5856 12.3303 15.6637C12.2522 15.7418 12.2083 15.8478 12.2083 15.9583Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.45825 9.91668C8.45825 10.3035 8.6119 10.6744 8.88539 10.9479C9.15888 11.2214 9.52981 11.375 9.91659 11.375C10.3034 11.375 10.6743 11.2214 10.9478 10.9479C11.2213 10.6744 11.3749 10.3035 11.3749 9.91668C11.3749 9.5299 11.2213 9.15897 10.9478 8.88548C10.6743 8.61199 10.3034 8.45834 9.91659 8.45834C9.52981 8.45834 9.15888 8.61199 8.88539 8.88548C8.6119 9.15897 8.45825 9.5299 8.45825 9.91668Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCovid.displayName = 'SvgCovid';
export default SvgCovid;
